export type EntityFileUploadCategory = "media" | "documents";

const DOCUMENT_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "text/csv",
]);

const isMediaMime = (mimeType: string) =>
  mimeType.startsWith("image/") || mimeType.startsWith("video/") || mimeType.startsWith("audio/");

export const ENTITY_FILE_UPLOAD_CONFIG = {
  media: {
    accept: "image/*,video/*,audio/*",
    rejectionMessage: "Only image, video, and audio files are allowed.",
    isAllowedMime: isMediaMime,
  },
  documents: {
    accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv",
    rejectionMessage: "Only PDF, Word, Excel, PowerPoint, text, and CSV files are allowed.",
    isAllowedMime: (mimeType: string) => DOCUMENT_MIME_TYPES.has(mimeType),
  },
} as const satisfies Record<
  EntityFileUploadCategory,
  { accept: string; rejectionMessage: string; isAllowedMime: (mimeType: string) => boolean }
>;

export function filterFilesByAllowedMime(files: FileList | File[], category: EntityFileUploadCategory) {
  const { isAllowedMime } = ENTITY_FILE_UPLOAD_CONFIG[category];
  const selected = Array.from(files);
  const accepted = selected.filter((file) => isAllowedMime(file.type));
  return { accepted, rejectedCount: selected.length - accepted.length };
}
